import { useContext } from 'react'
import { RefreshContext } from 'contexts/RefreshContext'

const useRefresh = () => {
  const { oneSec, fast, slow } = useContext(RefreshContext)
  return { oneSecRefresh: oneSec, fastRefresh: fast, slowRefresh: slow }
}

export default useRefresh
